// Single Handed — Narrated Excerpts Library
// Add new excerpts to the top of the array. Newest appears first.
// Required fields: id, title, description, audio, thumbnail
// Optional: duration, date

export const BOOK = {
  title: 'Single Handed',
  subtitle: 'Selected Excerpts from the Book by Lieutenant Joe Kress',
  author: 'Lieutenant Joseph M. Kress',
  cover:
    'https://customer-assets.emergentagent.com/job_substance-education-4/artifacts/yk3gbs8p_FB_IMG_1783978612595.jpg',
  intro:
    'Single Handed is Lieutenant Joe Kress’s first-hand account of one man’s fight against the drug crisis — written from the front lines of narcotics investigations, addiction, and community outreach. This page features selected narrated excerpts from the book to help visitors experience its message in the author’s own words and better understand the mission behind DrugAwarenessUSA.',
};

export const EXCERPTS = [
  {
    id: 'excerpt-5',
    title: 'Single Handed — Excerpt 5',
    description:
      'A continuing look inside Single Handed with another narrated selection from Lt. Joe Kress — real stories, unfiltered lessons.',
    audio:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/9xzysb27_excerpts%20pt%205.mp4',
    thumbnail:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/n2qjiy6m_part%205.jpg',
  },
  {
    id: 'excerpt-4',
    title: 'Single Handed — Excerpt 4',
    description:
      'Another narrated selection from Single Handed, drawing on Lt. Kress’s years of narcotics investigations and community work.',
    audio:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/fj3gwi6g_excerpts%20pt%204.mp4',
    thumbnail:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/on6wtguo_part%204.jpg',
  },
  {
    id: 'excerpt-3',
    title: 'Single Handed — Excerpt 3',
    description:
      'A narrated excerpt from Single Handed — a candid, on-the-ground perspective from a decorated Erie Police Lieutenant.',
    audio:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/zpvgfsi0_excerpts%20pt%203.mp4',
    thumbnail:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/32mf3ege_part%203.jpg',
  },
  {
    id: 'excerpt-2',
    title: 'Single Handed — Excerpt 2',
    description:
      'Continuing the story of Single Handed — real experiences, real consequences, and a call to make the right choice.',
    audio:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/iyaifmd1_excerpts%20pt%202.mp4',
    thumbnail:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/1r0w5lf8_part%202.jpg',
  },
  {
    id: 'excerpt-1',
    title: 'Single Handed — Excerpt 1',
    description:
      'The opening narrated excerpt from Single Handed — an introduction to Lt. Kress’s story and the mission behind his work.',
    audio:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/1tjgh91o_excerpts%20pt%201.mp4',
    thumbnail:
      'https://customer-assets-lqy194kg.emergentagent.net/job_substance-education-4/artifacts/3m0u8cv2_part%201.png',
  },
];
